import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomSanitizer } from '@angular/platform-browser';



@Injectable({ providedIn: 'root' })
export class RozgarMelaServiceService {
	currentUserRole: any;
	ROZGARMELA_AGENCY = 'Rozgarmela Agency'
	constructor(
		private apiService: ApiService,
		private sanitizer: DomSanitizer
	) { }

	getDropDownValues(key) {
		const getTypeofDropDown = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/meta?key=${key}`;
		return this.apiService.get(getTypeofDropDown);
	}

	getEligibilityCreateria() {
		const getTypeofDropDown = './../../../assets/data.json';
		return this.apiService.get(getTypeofDropDown);
	}

	createRozgarMela(data) {
		const getTargetAudience = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/`;
		return this.apiService.post(getTargetAudience, data);
	}

	getPostPlacementDetails(melaId) {
		const getmelaUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/postPlacementReport`;
		return this.apiService.get(getmelaUrl);
	}

	// api/user/v1/getUserBasedOnRole?role=SSC&query=address.state:tamil hja,address.district:kjhdsakh&pagno=0&limit=10
	getUserBasedOnRole(pageNo, itemsPerPage, userRole, queryParams?) {
		let getUserRole;
		const filterObj = {};
		// filterObj['role'] = userRole;
		// filterObj['address'] = {}
		if (itemsPerPage) {
			filterObj['limit'] = itemsPerPage;
		} else {
			filterObj['limit'] = 10;
		}
		if (pageNo) {
			filterObj['pageNo'] = pageNo;
		} else {
			filterObj['pageNo'] = 0;
		}
		if (queryParams) {
			if (queryParams.state !== '' && queryParams.district !== '') {
				// tslint:disable-next-line: max-line-length
				getUserRole = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?role=Employer&query=address.stateId:${queryParams.state.code},address.districtDetails.districtId:${queryParams.district}`
			} else if (queryParams.state !== '') {
				// tslint:disable-next-line: max-line-length
				getUserRole = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?role=Employer&query=address.stateId:${queryParams.state.code}`
			} else if (queryParams.district !== '') {
				// tslint:disable-next-line: max-line-length
				getUserRole = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?role=Employer&query=address.districtDetails.districtId:${queryParams.district}`
			} else {
				getUserRole = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?role=Employer`
			}
		} else {
			getUserRole = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?role=Employer`
		}
		console.log('SS ', filterObj);
		return this.apiService.get(getUserRole, filterObj);
	}

	getUserBasedOnRoleFilter(pageNo, itemsPerPage, userRole, queryParams?) {
		const filterObj = {};
		filterObj['role'] = userRole;
		if (queryParams) {
			if (queryParams.state !== '') {
				filterObj['state'] = queryParams.state.name;
			}
			if (queryParams.district !== '') {
				filterObj['district'] = queryParams.district;
			}
			if (queryParams.keyword !== '') {
				filterObj['keyword'] = queryParams.keyword;
			}
		}
		if (itemsPerPage) {
			filterObj['limit'] = itemsPerPage;
		} else {
			filterObj['limit'] = 10;
		}
		if (pageNo) {
			filterObj['pageNo'] = pageNo;
		} else {
			filterObj['pageNo'] = 0;
		}

		console.log('SS ', filterObj);
		const getUserRole = environment.userServiceUrl + '/api/user/v1/getUserNameBasedOnRoleFilter?'
		return this.apiService.get(getUserRole, filterObj);
	}


	updateRozgarMela(melaId, body) {
		const url = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/id/${melaId}`;
		// const url = environment.rozgarMelaUrl + '/api/user/v1/rozgarmela/id/' + melaId;
		return this.apiService.put(url, body);

	}
	public setDailyTime(time, startDate, endDate) {
		console.log(time);
		const startTime = (time.startTime);
		startDate = startDate.toString()
		const finalStartDate = startDate.replace(startDate.split(' ')[4], startTime);
		const endTime = (time.endTime);
		endDate = endDate.toString();
		const finalEndDate = endDate.replace(endDate.split(' ')[4], endTime);
		console.log(new Date(finalStartDate).toISOString());
		console.log(new Date(finalEndDate).toISOString());
		const data = {
			'startDate': new Date(finalStartDate).toISOString(),
			'endDate': new Date(finalEndDate).toISOString()
		};
		return data;
	}
	private _formatTime(time) {
		const AMPM = time.split(' ')[1];
		let hours = time.split(':')[0];
		// tslint:disable-next-line:radix
		hours = Number(hours);
		const minute = time.split(':')[1];
		// let seconds = time.split(':')[2];
		// seconds = seconds.split(' ')[0];
		if (AMPM === 'PM' && hours < 12) {
			hours = hours + 12;
			console.log(hours);
		}
		if (AMPM === 'AM' && hours === 12) {
			hours = hours - 12;
			console.log(hours);
		}
		// console.log(hours + ':' + minute + ':' + seconds);
		return hours + ':' + minute;
	}

	viewAllRozgarMelasByCanId(reqObj) {
		const queryParams = {};

		if (reqObj && reqObj !== undefined) {
			if (reqObj.tier) {
				queryParams['tier'] = reqObj.tier;
			}
			if (reqObj.filter && reqObj.filter.state) {
				queryParams['state'] = reqObj.filter.state;
			}
			if (reqObj.userName && reqObj.userName) {
				queryParams['userName'] = reqObj.userName;
			}
			if (reqObj.role && reqObj.role) {
				queryParams['role'] = reqObj.role;
			}
			if (reqObj.filter && reqObj.filter.district) {
				queryParams['district'] = reqObj.filter.district;
			}
			if (reqObj.filter && reqObj.filter.status) {
				queryParams['status'] = reqObj.filter.status;
			}
			if (reqObj.filter && reqObj.filter.startDate) {
				queryParams['startDate'] = reqObj.filter.startDate;
			}
			if (reqObj.filter && reqObj.filter.endDate) {
				queryParams['endDate'] = reqObj.filter.endDate;
			}
			if (reqObj.filter && reqObj.filter.keyword) {
				queryParams['search'] = reqObj.filter.keyword;
			}
			if (reqObj.filter && reqObj.filter.sector) {
				queryParams['sector'] = reqObj.filter.sector;
			}
			if (reqObj.filter && reqObj.filter.jobRoles) {
				queryParams['jobRoles'] = reqObj.filter.jobRoles;
			}
			if (reqObj.itemsPerPage) {
				queryParams['itemsPerPage'] = reqObj.itemsPerPage;
			} else {
				queryParams['itemsPerPage'] = 10;
			}
			if (reqObj.pageNo) {
				queryParams['pageNum'] = reqObj.pageNo;
			} else {
				queryParams['pageNum'] = 0;
			}
		}

		const URL = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/getMelaById?`
		return this.apiService.get(URL, queryParams);
	}

	viewAllRozgarMelas(reqObj) {
		const queryParams = {};

		if (reqObj && reqObj !== undefined) {
			if (reqObj.tier) {
				queryParams['tier'] = reqObj.tier;
			}
			if (reqObj.filter && reqObj.filter.state) {
				queryParams['state'] = reqObj.filter.state;
			}
			if (reqObj.filter && reqObj.filter.district) {
				queryParams['district'] = reqObj.filter.district;
			}
			if (reqObj.filter && reqObj.filter.status) {
				queryParams['status'] = reqObj.filter.status;
			}
			if (reqObj.filter && reqObj.filter.startDate) {
				queryParams['startDate'] = reqObj.filter.startDate;
			}
			if (reqObj.filter && reqObj.filter.endDate) {
				queryParams['endDate'] = reqObj.filter.endDate;
			}
			if (reqObj.filter && reqObj.filter.keyword) {
				queryParams['search'] = reqObj.filter.keyword;
			}
			if (reqObj.filter && reqObj.filter.sector) {
				queryParams['sector'] = reqObj.filter.sector;
			}
			if (reqObj.filter && reqObj.filter.jobRoles) {
				queryParams['jobRoles'] = reqObj.filter.jobRoles;
			}
			if (reqObj.itemsPerPage) {
				queryParams['itemsPerPage'] = reqObj.itemsPerPage;
			} else {
				queryParams['itemsPerPage'] = 10;
			}
			if (reqObj.pageNo) {
				queryParams['pageNum'] = reqObj.pageNo;
			} else {
				queryParams['pageNum'] = 0;
			}
		}

		const URL = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/`;
		return this.apiService.get(URL, queryParams);
	}

	getAllUsersBasedOnActors(pageNo, limit, role, param?, melaId?) {
		console.log(param);
		if (param) {
			const trainingCenterUrl = `${
				environment.userServiceUrl
				}/api/user/v1/getUserBasedOnRole?role=${role}&query=${param}&pageNo=${pageNo}&limit=${limit}&melaId=${melaId}`;
			return this.apiService.get(trainingCenterUrl);
		}
		const URL = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?role=${role}&pageNo=${pageNo}&limit=${limit}&melaId=${melaId}`;
		return this.apiService.get(URL);
	}


	public viewParticularMelaDetails(id) {
		const getTargetAudience = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/id/${id}`;
		return this.apiService.get(getTargetAudience);
	}
	reScheduleMela(melaId, body) {
		const URL = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/id/${melaId}`;
		return this.apiService.put(URL, body);
	}

	getAllSccDetailsOnids(data, role) {
		const query = {
			'ids': data
		}
		const getParticipated = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRoleAndIds?role=${role}&pageNo=1&limit=0`;
		return this.apiService.post(getParticipated, query);
	}

	getAllParticipatingUsersDetails(data, role, pageNo, limit, filter?) {
		let getParticipated: any;
		const query = {
			'ids': data
		}
		if (filter) {
			 getParticipated = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRoleAndIds?role=${role}&pageNum=${pageNo}&itemsPerPage=${limit}&query=${filter}`;
		} else {
			 getParticipated = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRoleAndIds?role=${role}&pageNum=${pageNo}&itemsPerPage=${limit}`;

		}
		return this.apiService.post(getParticipated, query);
	}

	viewParticipatedDetails(id?, role?, pageNo?, limit?, param?) {
		if (param) {
			const getParticipated = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRoleAndIds?ids=${id}&role=${role}&query=${param}&pageNo=${pageNo}&limit=${limit}`;
			return this.apiService.get(getParticipated);

		} else {
			const getParticipated = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRoleAndIds?ids=${id}&role=${role}&pageNo=${pageNo}&limit=${limit}`;
			return this.apiService.get(getParticipated);

		}
		// const getParticipated = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/id/${id}`;
	}
	viewMelaParticipatedCandidateDetails(melaId, pageNo, itemPerPage, modelObj?) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		if (modelObj && modelObj.state) {
			queryParams['state'] = modelObj.state.name;
		}
		if (modelObj && modelObj.district) {
			queryParams['district'] = modelObj.district.name
		}
		if (modelObj && modelObj.userId) {
			queryParams['searchEmp'] = modelObj.userId
		}



		// tslint:disable-next-line:max-line-length
		const participatedUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/CandidateReport/query`
		return this.apiService.get(participatedUrl, queryParams)
	}

	placedCandidateForEmp(melaId, pageNo, itemPerPage, modelObj?, empId?) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['searchEmpByUserName'] = empId
		queryParams['pageNum'] = pageNo;
		if (modelObj && modelObj.state) {
			queryParams['state'] = modelObj.state.name;
		}
		if (modelObj && modelObj.district) {
			queryParams['district'] = modelObj.district.name
		}
		if (modelObj && modelObj.userId) {
			queryParams['searchEmp'] = modelObj.userId
		}



		// tslint:disable-next-line:max-line-length
		const participatedUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/CandidateReport/query`
		return this.apiService.get(participatedUrl, queryParams)
	}
	viewMelaParticipatedDetails(melaId) {
		const participatedUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/query`;
		return this.apiService.get(participatedUrl)
	}

	viewUpcomingRozgarMela(reqObj) {
		const queryParams = {};

		if (reqObj && reqObj !== undefined) {
			if (reqObj.tier) {
				queryParams['tier'] = reqObj.tier;
			}
			if (reqObj.filter && reqObj.filter.state) {
				queryParams['state'] = reqObj.filter.state;
			}
			if (reqObj.filter && reqObj.filter.district) {
				queryParams['district'] = reqObj.filter.district;
			}
			if (reqObj.filter && reqObj.filter.startDate) {
				queryParams['startDate'] = reqObj.filter.startDate;
			}
			if (reqObj.filter && reqObj.filter.endDate) {
				queryParams['endDate'] = reqObj.filter.endDate;
			}
			if (reqObj.filter && reqObj.filter.keyword) {
				queryParams['search'] = reqObj.filter.keyword;
			}
			if (reqObj.filter && reqObj.filter.sector) {
				queryParams['sector'] = reqObj.filter.sector;
			}
			if (reqObj.filter && reqObj.filter.jobRoles) {
				queryParams['jobRoles'] = reqObj.filter.jobRoles;
			} if (reqObj && reqObj.status) {
				console.log('reqObj.status', reqObj.status);
				queryParams['status'] = reqObj.status;
			}
			// if (reqObj && reqObj.draft) {
			// 	queryParams['status'] = reqObj.draft;
			// }
			// if (reqObj.filter && reqObj.cancelled) {
			// 	queryParams['status'] = reqObj.filter.cancelled;
			// }
			if (reqObj.itemsPerPage) {
				queryParams['itemsPerPage'] = reqObj.itemsPerPage;
			} else {
				queryParams['itemsPerPage'] = 10;
			}
			if (reqObj.pageNo) {
				queryParams['pageNum'] = reqObj.pageNo;
			} else {
				queryParams['pageNum'] = 0;
			}
		}
		const URL = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/`;
		return this.apiService.get(URL, queryParams);
	}

	viewParticipatedDetailsbasedOnFilter(melaId, role, query) {
		const queryFilter = {}
		queryFilter['role'] = role;
		queryFilter['melaId'] = melaId;
		queryFilter['searchOn'] = 'userName';
		if (query.userId !== '') {
			queryFilter['search'] = query.userId;
		}
		const getParticipated = `${environment.userServiceUrl}/api/user/v1/getUserByMelaId?`;
		return this.apiService.get(getParticipated, queryFilter);
	}

	createEmployers(employersDetails) {
		employersDetails['employerType'] = 'rozgarMela'
		const createEmployer = `${environment.userServiceUrl}/v1/employers/register`;
		return this.apiService.post(createEmployer, employersDetails);
	}

	getRocDropDownValues() {
		const getRocDropUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/meta?key=registrarOfCompanies`;
		return this.apiService.get(getRocDropUrl);
	}

	cancelRozgarMela(rozgarMelaId) {
		const cancelMelaUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/delete/${rozgarMelaId}`;
		return this.apiService.patch(cancelMelaUrl);
	}

	closeCandiditeRegistration(rozgarMelaId) {
		const cancelcanRegMelaUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/update/${rozgarMelaId}/candidateStatus/Closed`;
		return this.apiService.patch(cancelcanRegMelaUrl);
	}

	rescheduleMela(rozgarMelaId, rescheduleData) {
		const rescheduleMelaUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/reschedule/${rozgarMelaId}`;
		return this.apiService.put(rescheduleMelaUrl, rescheduleData);
	}

	attendMelaByCandidate(candidateId, melaId) {
		const rescheduleMelaUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/candidateAttend/${candidateId}`;
		return this.apiService.put(rescheduleMelaUrl, melaId);
	}
	applyForMelaByCandidate(melaId) {
		const rescheduleMelaUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/id/${melaId}/candidateAttend`;
		return this.apiService.patch(rescheduleMelaUrl);
	}
	createJobFairSpoc(data) {
		const fairspocUrl = `${environment.userServiceUrl}/api/user/v1/register/JFSPOC`;
		console.log('fairspoc', fairspocUrl);
		return this.apiService.post(fairspocUrl, data);
	}
	// http://localhost:3333/api/v1/rozgarmela/jobVacency
	createJobVacancy(data) {
		const jobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/jobVacancy`;
		return this.apiService.post(jobVacancyUrl, data);
	}
	getAllJobVacancy() {
		const alljobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/jobVacancy/all`;
		return this.apiService.get(alljobVacancyUrl);
	}
	updatepostPlacement(data) {
		const updatepostPlacementUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/postPlacement`;
		return this.apiService.post(updatepostPlacementUrl, data);
	}


	getSectorsUserNames() {
		const sscUserListUrl = `${environment.userServiceUrl}/api/user/v1/ssc?param=userName`;
		return this.apiService.get(sscUserListUrl);
	}
	announceToStakeHolder(data, melaId) {
		const announceToStakeHolderUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/announceStack/${melaId}`;
		return this.apiService.post(announceToStakeHolderUrl, data);
	}
	getEmployeerByID(id?) {
		const getEmployeerUrl = `${environment.userServiceUrl}/v1/employers/byId/${id}`;
		return this.apiService.get(getEmployeerUrl);
	}
	getJobVacancy(pageNo, itemsPerPage, melaId, query?) {
		const filterObj = {};
		if (query) {
			if (query.userId !== '') {
				filterObj['userName'] = query.userId;
			}
		}

		if (itemsPerPage) {
			filterObj['limit'] = itemsPerPage;
		} else {
			filterObj['limit'] = 10;
		}
		if (pageNo) {
			filterObj['pageNo'] = pageNo;
		} else {
			filterObj['pageNo'] = 0;
		}
		// tslint:disable-next-line:max-line-length
		const jobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/jobVacancyByMelaId/${melaId}?`;
		return this.apiService.get(jobVacancyUrl, filterObj);
	}
	getAllDignitaries(melaId) {
		const AllDignitariesUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/postPlacement/${melaId}`;
		return this.apiService.get(AllDignitariesUrl);
	}
	getSectorById(sectorId) {
		const sectorByIdUrl = `${environment.sqaServiceUrl}/api/sqa/sectors/subsectors/${sectorId}`;
		return this.apiService.get(sectorByIdUrl)
	}

	candidatesBulkRegistration(file) {
		const url = `${environment.userServiceUrl}/v1/candidates/reg/bulkupload/tp/enrollV2`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(url, formData);
	}

	registerCandidatesToMela(melaId: string, candidates: string[], candidateDetails: object[]) {
		const url = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/candidateAttend/xls/${melaId}`;
		return this.apiService.patch(url, { userNames: candidates, UserDetails: candidateDetails });
	}

	downLoadOfferLetter(candidateId, melaId) {
		const url = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/getCandidateOfferLetter/${candidateId}`;
		return this.apiService.get(url);
	}

	pagination(pageNo, selectedPage, totalLength, existingDataLength) {
		let pagination: { start: number, end: number, pageNo: number };
		if (pageNo < selectedPage) {
			return pagination = {
				start: (existingDataLength * (selectedPage - 1)),
				end: ((existingDataLength * (selectedPage - 1)) + 10),
				pageNo: selectedPage
			}
		} else {
			pageNo = selectedPage;
			existingDataLength = 10;
			return pagination = {
				start: (existingDataLength * (selectedPage - 1)),
				end: (existingDataLength * (selectedPage - 1)) + 10,
				pageNo: pageNo
			}
		}
	}
	getAllJobVacancyDropDown(melaId) {
		const jobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/jobVacancyByMelaId/${melaId}`;
		return this.apiService.get(jobVacancyUrl);
	}
	OfferedJobVacancyEmployerDropDown(melaId, empId) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['jobCreatorUserId'] = empId;
		const getOffoeredJobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/query`;
		return this.apiService.get(getOffoeredJobVacancyUrl, queryParams);
	}
	getJobVacancyByJobId(jobId) {
		const jobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/jobVacancyById/${jobId}`;
		return this.apiService.get(jobVacancyUrl);
	}

	getPlacedCandidate(itemsPerPage, pageNo, query?, melaId?) {
		const filterObj = {};
		if (query) {
			if (query.userId !== '') {
				filterObj['userName'] = query.userId;
			}
		}
		if (itemsPerPage) {
			filterObj['itemsPerPage'] = itemsPerPage;
		} else {
			filterObj['itemsPerPage'] = 10;
		}
		if (pageNo) {
			filterObj['pageNo'] = pageNo;
		} else {
			filterObj['pageNo'] = 0;
		}
		// tslint:disable-next-line:max-line-length
		const placedCandidateUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/placement/candidate?melaId=${melaId}`;
		return this.apiService.get(placedCandidateUrl, filterObj);
	}
	updatePlaceMentDetails(data) {
		// tslint:disable-next-line:max-line-length
		const placedCandidateUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/placement/candidate`
		return this.apiService.post(placedCandidateUrl, data);
	}

	updateStatus(rozarId, status) {
		const url = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/update/${rozarId}/status/${status}`;
		// const url = environment.rozgarMelaUrl + '/api/user/v1/rozgarmela/id/' + melaId;
		return this.apiService.patch(url);
	}

	downloadReportByMelaId(melaId) {
		const pdfUrl = `${environment.pdfGenerate}/api/v1/generatepdfreports/rozgarmela/?melaId=${melaId}`;
		// const url = environment.rozgarMelaUrl + '/api/user/v1/rozgarmela/id/' + melaId;
		return this.apiService.getBlob(pdfUrl, 'application/pdf');
	}

	downloadReportForAllMela(reqObj, type) {
		let queryParams = {};
		if (reqObj.filter && reqObj.filter.startDate) {
			queryParams['startDate'] = reqObj.filter.startDate;
		}
		if (reqObj.filter && reqObj.filter.endDate) {
			queryParams['endDate'] = reqObj.filter.endDate;
		}
		if (type) {
			queryParams['tier'] = type;
		}
		const pdfUrl = `${environment.pdfGenerate}/api/v1/generatepdfreports/rozgarmela/`;
		// const url = environment.rozgarMelaUrl + '/api/user/v1/rozgarmela/id/' + melaId;
		return this.apiService.getBlob(pdfUrl, 'application/zip', queryParams);
	}

	getAllTrainingCenters(query, filter) {
		let url;
		if (filter) {
			// if (filter.address.state.name || filter.address.district.name || filter.userName) {
			// tslint:disable-next-line:max-line-length
			url = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?param=userName,address,trainingCenterType,trainingPartner&query=${filter}`;
			// }
		} else {
			// tslint:disable-next-line:max-line-length
			url = `${environment.userServiceUrl}/api/user/v1/getUserBasedOnRole?param=userName,address,trainingCenterType,trainingPartner`;

		}
		return this.apiService.get(url, query);
	}

	// 	userName: element.userName,
	// state: element.address && element.address.state && element.address.state.name,
	// district: element.address && element.address.district && element.address.district.name,
	// parliamentaryConstituency: element.address && element.address.parliamentaryConstituency &&
	// 	element.address.parliamentaryConstituency.name,
	// tcType: element.trainingCenterType,
	// tcName: element.trainingCentreName,
	// tpName: element.trainingPartner && element.trainingPartner.name

	getMelaParticipationSummary(melaId) {
		const participationSummaryUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/participationSummary/${melaId}`;
		return this.apiService.get(participationSummaryUrl)
	}
	getMelaSourcingSummary(melaId) {
		const participationSummaryUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/participationSummary/query`;
		return this.apiService.get(participationSummaryUrl)
	}
	getParticipatedEmployer(melaId, empId) {
		console.log(empId)
		// tslint:disable-next-line:max-line-length
		const EmployerSourcingSummary = `${environment.userServiceUrl}/v1/employers/participatingSummary?ids=${empId}&melaId=${melaId}`;
		return this.apiService.get(EmployerSourcingSummary)
	}
	getParticipateMelaEmployer(melaId, pageNo, itemPerPage) {
		// tslint:disable-next-line:max-line-length
		const participatedEmployerUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/RZM_000004/EmployerReport/query?pageNum=${pageNo}&itemsPerPage=${itemPerPage}`
		return this.apiService.get(participatedEmployerUrl);
	}
	removeEmployerFromMela(melaId, payload, role) {
		const removeEmployerUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/removeAllignUser?melaId=${melaId}&role=${role}`;
		return this.apiService.patch(removeEmployerUrl, payload)
	}
	updateCandidateProfile(userName, body) {
		const updateProfileUrl = `${environment.userServiceUrl}/v1/candidates/patchCandidate/${userName}`
		// const updateProfileUrl = `${environment.userServiceUrl}/v1/candidates/${userName}`
		return this.apiService.patch(updateProfileUrl, body)
	}
	participateCandiReport(melaId) {
		const DownloadReportUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/CandidateReport/Download`;
		return this.apiService.getBlob(DownloadReportUrl, 'application/vnd.ms-excel');
	}
	participateEmpReport(melaId) {
		const DownloadReportUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/EmployerReport/Download`;
		return this.apiService.getBlob(DownloadReportUrl, 'application/vnd.ms-excel');
	}
	downloadReportBasedOnOperations(melaId, operation) {
		const DownloadReportUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/${operation}/Download`;
		return this.apiService.getBlob(DownloadReportUrl, 'application/vnd.ms-excel');
	}
	offeredJonVacanciesReport(melaId) {
		const DownloadJobVacanReportUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/Download`;
		return this.apiService.getBlob(DownloadJobVacanReportUrl, 'application/vnd.ms-excel');
	}
	employerSourceSummaryReport(melaId) {
		// tslint:disable-next-line:max-line-length
		const employerSourceSummaryRoportUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/participationSummary/Download`;
		return this.apiService.getBlob(employerSourceSummaryRoportUrl, 'application/vnd.ms-excel');
	}

	_downloadFile(data: any, name: string) {
		let fileUrl;
		fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
		const a = document.createElement('a');
		a.href = fileUrl.changingThisBreaksApplicationSecurity;
		a.download = name;
		document.body.appendChild(a);
		a.click();
	}


	melaOfferedJobVacancies(melaId, pageNo, itemPerPage) {
		// tslint:disable-next-line:max-line-length
		const JobVacanReportUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/query?pageNum=${pageNo}&itemsPerPage=${itemPerPage}`;
		return this.apiService.get(JobVacanReportUrl);
	}
	participateMelaEmployer(melaId, pageNo, itemPerPage, modelObj) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		if (modelObj && modelObj.state) {
			queryParams['state'] = modelObj.state.name;
		}
		if (modelObj && modelObj.district) {
			queryParams['district'] = modelObj.district.name
		}
		if (modelObj && modelObj.userId) {
			queryParams['userName'] = modelObj.userId
		}
		const getEmpUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/EmployerReport/query`;
		return this.apiService.get(getEmpUrl, queryParams);
	}
	participatedMelaTrainingCentre(melaId, pageNo?, itemPerPage?, modelObj?) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		if (modelObj && modelObj.state) {
			queryParams['state'] = modelObj.state.name;
		}
		if (modelObj && modelObj.district) {
			queryParams['district'] = modelObj.district.name
		}
		if (modelObj && modelObj.userId) {
			queryParams['search'] = modelObj.userId
		}
		const getTcUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/TrainingCenterReport/query`;
		return this.apiService.get(getTcUrl, queryParams);
	}

	getOfferedJobVacancy(melaId, pageNo, itemPerPage, modelObj) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		if (modelObj && modelObj.state) {
			queryParams['state'] = modelObj.state.name;
		}
		if (modelObj && modelObj.district) {
			queryParams['district'] = modelObj.district.name
		}
		if (modelObj && modelObj.userId) {
			queryParams['search'] = modelObj.userId
		}
		const getOffoeredJobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/query`;
		return this.apiService.get(getOffoeredJobVacancyUrl, queryParams);
	}
	getOfferedJobVacancyEmployer(melaId, pageNo, itemPerPage, modelObj, empId) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		queryParams['jobCreatorUserId'] = empId
		if (modelObj && modelObj.state) {
			queryParams['state'] = modelObj.state.name;
		}
		if (modelObj && modelObj.district) {
			queryParams['district'] = modelObj.district.name
		}
		if (modelObj && modelObj.userId) {
			queryParams['search'] = modelObj.userId
		}
		const getOffoeredJobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/query`;
		return this.apiService.get(getOffoeredJobVacancyUrl, queryParams);
	}
	isJobVacancy(melaId, empId) {
		const queryParams = {}
		queryParams['jobCreatorUserId'] = empId
		const getOffoeredJobVacancyUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobVacancyReportByMelaId/query`;
		return this.apiService.get(getOffoeredJobVacancyUrl, queryParams)
	}
	getEmployerSourceSummary(melaId, pageNo, itemPerPage, modelObj) {
		// tslint:disable-next-line:prefer-const
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		if (modelObj && modelObj.name) {
			queryParams['search'] = modelObj.name
		}
		const employerSourceSummaryUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/participationSummary/query`;
		return this.apiService.get(employerSourceSummaryUrl, queryParams);
	}
	uploadPlacedCandidate(file, melaId) {
		const uploadUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/PlacedCandidateXlsUpload`;
		const formData = new FormData();
		formData.append('file', file);
		return this.apiService.post(uploadUrl, formData);
	}
	// downloadRozgarMelaAdmitCard(canId, melaId) {
	// 	const downloadUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/candidateId/${canId}/admitCard`;
	// 	return this.apiService.get(downloadUrl, 'text/html');
	// }
	getTaregetAudience(data) {
		let keys = Object.keys(data);
		let filtered = keys.filter(function (key) {
			return data[key]
		});
		return filtered.toString();
	}

	uploadMouForEmployer(data, userName) {
		let reqobj = {
			'mou': data
		}
		const uploadUrl = `${environment.userServiceUrl}/v1/employers/mou/${userName}`;
		return this.apiService.patch(uploadUrl, reqobj);
	}
	getJobFairSpoc(melaId, empId?, jfsId?, pageNo?, itemPerPage?) {
		let queryParams = {}
		if (itemPerPage) {
			queryParams['itemsPerPage'] = itemPerPage;
		}
		if (pageNo) {
			queryParams['pageNum'] = pageNo;
		}
		if (empId) {
			queryParams['employerId'] = empId;
		}
		if (jfsId) {
			queryParams['jfsId'] = jfsId;
		}
		const jobFairSpocUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobfairSpock`;
		return this.apiService.get(jobFairSpocUrl, queryParams)

	}
	getAllJobFairSpoc(melaId, pageNo?, itemPerPage?) {
		let queryParams = {}
		queryParams['itemsPerPage'] = itemPerPage;
		queryParams['pageNum'] = pageNo;
		const jobFairSpocUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobfairSpock`;
		return this.apiService.get(jobFairSpocUrl, queryParams)
	}
	getParticularSpoc(melaId, jfsId) {
		let queryParams = {}
		queryParams['jfsId'] = jfsId;
		const jobFairSpocUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/jobfairSpock`;
		return this.apiService.get(jobFairSpocUrl, queryParams)
	}
	downloadAdmitCardForMela(melaId, canId) {
		const admitCardUrl = `${environment.pdfGenerate}/api/v1/generatepdfreports/generatepdfadmitcard/rozgarmela/${melaId}/user/${canId}`;
		return this.apiService.getBlob(admitCardUrl, 'application/pdf');
	}
	claimRozgarMelaFee(melaId) {
		const claimFeeUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/GetClaimFeeReport`
		return this.apiService.get(claimFeeUrl)
	}
	getMelaFeeInvoice() {
		const invoiceSlipUrl = `${environment.pdfGenerate}/api/v1/generatepdfreports/claimFee`;
		return this.apiService.getBlob(invoiceSlipUrl, 'application/pdf');
	}

	isMelaCreatedByOwner(melaId, userName) {
		const checkUrl = `${environment.rozgarMelaUrl}/api/v1/rozgarmela/melaId/${melaId}/checkUserAlign/role/SSC/user/${userName}`;
		return this.apiService.get(checkUrl)
	}
}

